/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 * /

/**
 * @class ToolbarSectionAPI
 * @hideconstructor
 * @classdesc API class that is used to manage the Canvas Toolbar Dock.
 */
define([], () => {
	class ToolbarSectionAPI{
		/**
		 * @function ToolbarSectionAPI#getReactElement
		 * @description provide a React element represents this feature
		 * @return {ReactElement} a React Element
		 */
		getReactElement(){}

		/**
		 * @function ToolbarSectionAPI#setNode
		 * @description let the UI implementation set the node which represent this feature
		 * @param {Node} a DOM node
		 */
		setNode(){}

		/**
		 * @function ToolbarSectionAPI#getNode
		 * @description provide the DOM node of this feature
		 * @returns {Node} a DOM node
		 */
		getNode(){}

		/**
		 * @function ToolbarSectionAPI#getIndex
		 * @description provide the index of this feature
		 * @return {Integer} int
		 */
		getIndex(){}
	}

	return ToolbarSectionAPI;
});
